/**
 * Created by Workaxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Date: 06/07/23
 * Time: 11:43 pm
 * Project: W-CRM-Frontend
 */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SyncState } from "../redux/sync/syncReducer";
import { authState } from "../redux/auth/authReducer";
import { getCookie } from "../utils/cookies";
import { ACCOUNTS_COOKIE_KEY, ACTIVE_ACCOUNT_COOKIE_KEY } from "../utils/constants";
import { isJwtValid } from "../utils/common";
import "./style.css";

export default function SharedLayout({ component: Component, ...rest }) {
  const { current: sync } = useSelector(SyncState);
  const [lastSync, setLastSync] = useState(0);
  useEffect(() => {
    if (lastSync !== sync.time) {
      setLastSync(sync.time);
    }
  }, [sync.time, lastSync]);

  const auth = useSelector(authState);
  const [isLogged, setIsLogged] = useState(false);
  useEffect(() => {
    let accessToken = null;
    const activeId = getCookie(ACTIVE_ACCOUNT_COOKIE_KEY);
    if (activeId) {
      try {
        const accounts = JSON.parse(getCookie(ACCOUNTS_COOKIE_KEY) || "[]");
        const acc = accounts.find((acc) => acc.id.toString() === activeId.toString());
        if (acc) accessToken = acc.access;
      } catch (e) { }
    }

    if (accessToken === null) {
      setIsLogged(false);
    } else {
      if (!isJwtValid(accessToken)) {
        setIsLogged(false);
      } else {
        setIsLogged(true);
      }
    }
  }, [auth.isAuthenticated]);

  return (
    <div className={"sharedLayout-Container"}>
      <Component />
    </div>
  );
}
